const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  post: {
    root: `/post`,
    details: (slug) => `/post/${slug}`,
  },
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    verify: `${ROOTS.AUTH}/verify`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    reactivate: `${ROOTS.DASHBOARD}/reactivate`,
    crm: {
      root: (crmKey) => `${ROOTS.DASHBOARD}/crm/${crmKey}`,
      new: (crmKey) => `${ROOTS.DASHBOARD}/crm/${crmKey}/new`,
      edit: (crmKey, id) => `${ROOTS.DASHBOARD}/crm/${crmKey}/${id}/edit`,
      account: (crmKey, id) => `${ROOTS.DASHBOARD}/crm/${crmKey}/${id}/account`,
      activities: `${ROOTS.DASHBOARD}/crm/activities`,
      settings: {
        root: `${ROOTS.DASHBOARD}/crm/settings`,
        new: `${ROOTS.DASHBOARD}/crm/settings/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/crm/settings/${id}/edit`,
      },
      pipelines: {
        root: `${ROOTS.DASHBOARD}/crm/pipelines`,
        new: `${ROOTS.DASHBOARD}/crm/pipelines/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/crm/pipelines/${id}/edit`,
      },
      data_import: {
        root: `${ROOTS.DASHBOARD}/crm/data_import`,
        new: `${ROOTS.DASHBOARD}/crm/data_import/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/crm/data_import/${id}/edit`,
      },
      layouts: {
        root: (crmKey) => `${ROOTS.DASHBOARD}/crm/layouts/${crmKey}`,
      },
    },
    landing_pages: {
      root: `${ROOTS.DASHBOARD}/landing-pages`,
      new: `${ROOTS.DASHBOARD}/landing-pages/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/landing-pages/${id}/edit`,
    },
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      new: `${ROOTS.DASHBOARD}/users/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/users/${id}/edit`,
      teams: {
        root: `${ROOTS.DASHBOARD}/users/teams`,
        new: `${ROOTS.DASHBOARD}/users/teams/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/users/teams/${id}/edit`,
      },
      permissions: {
        root: `${ROOTS.DASHBOARD}/users/permissions`,
        new: `${ROOTS.DASHBOARD}/users/permissions/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/users/permissions/${id}/edit`,
      }
    },
    blogs: {
      root: `${ROOTS.DASHBOARD}/blogs`,
      new: `${ROOTS.DASHBOARD}/blogs/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/blogs/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/blogs/${id}/view`
    },
    reviews: {
      root: `${ROOTS.DASHBOARD}/reviews`,
      new: `${ROOTS.DASHBOARD}/reviews/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/reviews/${id}/edit`,
    },
    websites: {
      root: `${ROOTS.DASHBOARD}/websites`,
      new: `${ROOTS.DASHBOARD}/websites/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/websites/${id}/edit`,
    },
    gallery: {
      root: `${ROOTS.DASHBOARD}/gallery`,
    },
  },
};
